import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type LanguageDataType = {
  id: number;
  code: string;
  image: string;
  is_visible: boolean;
  name: string;
};

type LanguageState = {
  selectedLanguage: LanguageDataType | null;
};

export const defaultLanguage: LanguageDataType = {
  id: 19,
  code: "AZ",
  image: "https://1412api.bionet.az/storage/uploads/languages/1736613525_67829e95d40ed.png",
  is_visible: true,
  name: "Azerbaijani",
};

const initialState: LanguageState = {
  selectedLanguage: defaultLanguage,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<LanguageDataType>) => {
      state.selectedLanguage = action.payload;
      localStorage.setItem("lang", action.payload.code?.toLowerCase() || "az");
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
